import { Box, Flex, Heading, Text, Badge, VStack, HStack } from '@chakra-ui/react'
import Copy from '../../../../../assets/svg/copy'
import PatientInfoItem from './components/patientInfoItem'
import moment from 'moment'
import { useMemo } from 'react'
import { IPatient } from '../../../../../types/patients'
import { useTranslation } from 'react-i18next'

const PatientInfo = ({ patientData }: { patientData: IPatient }) => {
  const { t } = useTranslation()
  const patient = useMemo<
    IPatient & { yearOld: number; dateOFBird: string; fullDateDisplay: string }
  >(() => {
    const yearOld = moment().diff(moment(patientData?.dateOfBirth), 'years')
    const dateOFBird = moment(patientData?.dateOfBirth).format('DD MMM YYYY')
    return {
      ...patientData,
      yearOld,
      dateOFBird,
      fullDateDisplay: `${dateOFBird} (${yearOld} ${t('shared.common.yearsOld')}
      )`,
    }
  }, [patientData, t])

  return (
    <Box bg="white" borderRadius="xl" p={5} mb={4} boxShadow="md" borderWidth="1px" borderColor="gray.100">
      <Heading fontFamily={'Poppins'} as={'p'} size="sm" color="purple.700" mb={4}>
        {t('patient.titleInfo')}
      </Heading>

      <VStack align="stretch" spacing={4}>
        <HStack justify="space-between" align="center">
          <VStack align="start" spacing={0}>
            <Text fontSize="lg" fontWeight="bold" color="gray.800">
              {patient.firstName} {patient.lastName}
            </Text>
            {patient?.birthName && (
              <Text fontSize="sm" color="gray.500">
                {t('shared.common.birthNameLabel')}: {patient.birthName}
              </Text>
            )}
          </VStack>
          <Badge colorScheme="purple" variant="subtle" borderRadius="full" px={3} py={1}>
            {patient.gender}
          </Badge>
        </HStack>

        <Flex gap={3} wrap="wrap">
          <PatientInfoItem
            title={t('patient.id')}
            info={patient.id}
            iconCopy={<Copy />}
          />
          <PatientInfoItem
            title={t('patient.socialSecurityNumberShortLabel')}
            info={patient.socialSecurityNumber ?? undefined}
          />
          <PatientInfoItem
            title={t('shared.common.dateOfBirthLabel')}
            info={patient?.fullDateDisplay}
          />
        </Flex>

        <Flex gap={3} wrap="wrap">
          <PatientInfoItem
            title={t('shared.common.fullAddressLabel')}
            info={patient.address}
          />
          {patient.phoneNumber && (
            <PatientInfoItem
              title={t('shared.common.phoneLabel')}
              info={patient.phoneNumber}
            />
          )}
        </Flex>
      </VStack>
    </Box>
  )
}

export default PatientInfo
